import React from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { perfectFor } from "../../mock";
import { Button } from "../ui/button";
import Reveal from "../Reveal";

export default function PerfectFor() {
  const scrollBook = () => document.getElementById("book-form")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <h2 className="font-display text-3xl sm:text-4xl text-ink">{perfectFor.title}</h2>
          <p className="mt-4 text-lg text-muted-foreground">{perfectFor.intro}</p>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 flex flex-wrap gap-3">
            {perfectFor.tags.map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold-soft/50 px-5 py-2.5 text-[15px] font-medium text-ink hover:bg-gold hover:border-gold transition-colors cursor-default"
              >
                <MapPin size={15} className="text-gold-dark" /> {t}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 rounded-2xl border border-gold/25 bg-gold-soft/40 p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
            <p className="text-lg text-ink font-medium max-w-2xl">{perfectFor.footnote}</p>
            <Button
              onClick={scrollBook}
              className="h-12 px-7 rounded-full bg-ink hover:bg-gold hover:text-ink text-white font-semibold whitespace-nowrap group"
            >
              Book Free Site Visit <ArrowRight size={17} className="ml-1.5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
